module.exports = __webpack_public_path__ + "front/img/2.e0f0e1d8.png";